/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_LayerInputs */

const en_fw_bm_col_layer = /** @type {(inputs: Fw_Bm_Col_LayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layer`)
};

const id_fw_bm_col_layer = /** @type {(inputs: Fw_Bm_Col_LayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapisan`)
};

/**
* | output |
* | --- |
* | "Layer" |
*
* @param {Fw_Bm_Col_LayerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_layer = /** @type {((inputs?: Fw_Bm_Col_LayerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_LayerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_layer(inputs)
	return en_fw_bm_col_layer(inputs)
});